import React from 'react';

/**
 * RN Academy brand logo — recreated as crisp SVG.
 * Three colored squares in an L-pattern + wordmark "RN Academy"
 * + tagline "THE NEW AGE LEARNING SOLUTIONS".
 */
export default function Logo({ size = 44, light = false, showTagline = true }) {
  const coral = '#ee5a47';
  const coralLight = '#f47c6c';
  const yellow = '#f5c54a';
  const textMain = light ? '#ffffff' : '#2b1d18';
  const textSub = light ? 'rgba(255,255,255,0.8)' : '#9a6b5a';

  const s = size; // base block size for the mark
  const gap = s * 0.06;
  const tile = (s - gap) / 2; // size of each square

  return (
    <div className="flex items-center gap-3">
      {/* Mark — 3 colored squares in L pattern */}
      <svg
        width={s}
        height={s}
        viewBox={`0 0 ${s} ${s}`}
        xmlns="http://www.w3.org/2000/svg"
        aria-label="RN Academy"
        className="shrink-0"
      >
        {/* top-left: coral */}
        <rect x="0" y="0" width={tile} height={tile} rx={tile * 0.08} fill={coralLight} />
        {/* bottom-left: yellow */}
        <rect x="0" y={tile + gap} width={tile} height={tile} rx={tile * 0.08} fill={yellow} />
        {/* bottom-right: coral (deeper) */}
        <rect x={tile + gap} y={tile + gap} width={tile} height={tile} rx={tile * 0.08} fill={coral} />
      </svg>

      {/* Wordmark */}
      <div className="leading-none">
        <div
          className="font-serif font-semibold"
          style={{ color: textMain, fontSize: s * 0.42, letterSpacing: '-0.01em' }}
        >
          RN Academy
        </div>
        {showTagline && (
          <div
            className="mt-1 tracking-[0.18em] uppercase font-medium"
            style={{ color: textSub, fontSize: s * 0.18 }}
          >
            The New Age Learning Solutions
          </div>
        )}
      </div>
    </div>
  );
}
